import React from 'react'
import { DataTable } from './DataTable'
import { YhBox } from '@/components/YhBox'
import { FullOrderEnum, useFullOrderModel } from '../fullOrderModel'
import { Button, Dropdown, Menu } from 'antd'
import useGlobalModel from '@/model/globalModel'
import { DownOutlined } from '@ant-design/icons'

export const DataBox = () => {
    const { fullOrderStatus, setFullOrderStatus, fullOrderExport, resetParam, fullOrderSimplExport } = useFullOrderModel()
    const { userBranch } = useGlobalModel()
    const action = (
        <>
            <Button
                className={`mr-5 ${fullOrderStatus === FullOrderEnum.purchase ? 'tab-buts-active' : ''}`}
                type="link"
                shape="round"
                onClick={() => {
                    setFullOrderStatus(FullOrderEnum.purchase)
                    resetParam()
                }}
            >
                采购
            </Button>
            <Button
                className={`mr-5 ${fullOrderStatus === FullOrderEnum.sale ? 'tab-buts-active' : ''}`}
                type="link"
                shape="round"
                onClick={() => {
                    setFullOrderStatus(FullOrderEnum.sale)
                    resetParam()
                }}
            >
                销售
            </Button>
            {userBranch === 'vrm' || userBranch === 'ci' ? (
                <>
                    <Button
                        className={`mr-5 ${fullOrderStatus === FullOrderEnum.repair ? 'tab-buts-active' : ''}`}
                        type="link"
                        shape="round"
                        onClick={() => {
                            setFullOrderStatus(FullOrderEnum.repair);
                            resetParam();
                        }}
                    >
                        维修-Vrm
                    </Button>

                    <Button
                        className={`mr-5 ${fullOrderStatus === FullOrderEnum.ciRepair ? 'tab-buts-active' : ''}`}
                        type="link"
                        shape="round"
                        onClick={() => {
                            setFullOrderStatus(FullOrderEnum.ciRepair);
                            resetParam();
                        }}
                    >
                        维修-Ci
                    </Button>
                </>
            ) :userBranch === 'bcm'||userBranch === 'vrm-nga'||userBranch === 'vrm-nga-s'||userBranch === 'vrm-nga-yh' ? (
                <>
                    <Button
                        className={`mr-5 ${fullOrderStatus === FullOrderEnum.repair ? 'tab-buts-active' : ''}`}
                        type="link"
                        shape="round"
                        onClick={() => {
                            setFullOrderStatus(FullOrderEnum.repair);
                            resetParam();
                        }}
                    >
                        维修
                    </Button>
                </>
            ): (
                <></>
            )}
            {userBranch === 'bcm' ? (
                <Button
                    className={`mr-5 ${fullOrderStatus === FullOrderEnum.bus ? 'tab-buts-active' : ''}`}
                    type="link"
                    shape="round"
                    onClick={() => {
                        setFullOrderStatus(FullOrderEnum.bus)
                        resetParam()
                    }}
                >
                    公交销售
                </Button>
            ) : (
                <></>
            )}
        </>
    )

    const exportMenu = () => (
        <Menu>
            <Menu.Item key="0">
                <span onClick={() => fullOrderExport(fullOrderStatus)}>常规导出</span>
            </Menu.Item>
            <Menu.Item key="1">
                <span onClick={() => fullOrderSimplExport(fullOrderStatus)}>对账单导出</span>
            </Menu.Item>
        </Menu>
    )

    const boxAction =
        userBranch === 'scm' && fullOrderStatus === FullOrderEnum.sale ? (
            <Dropdown overlay={exportMenu}>
                <Button className="mr-5 btn-item" type="link" shape="round">
                    导出
                    <DownOutlined />
                </Button>
            </Dropdown>
        ) : (
            <>
                <Button className="mr-5" type="link" shape="round" onClick={() => fullOrderExport(fullOrderStatus)}>
                    导出
                </Button>
            </>
        )

    return (
        <>
            <YhBox title={action}></YhBox>
            <YhBox action={boxAction}>
                <DataTable />
            </YhBox>
        </>
    )
}
